import { BroadcastChannel } from 'broadcast-channel';
import { ALFA_ID_CHANNEL } from 'src/components/AuthNew/hooks/constants';
import type { AlfaAuthResult } from 'src/components/AuthNew/hooks/useAlfaAuth';

export const AlfaHandler = () => {
  const channel = new BroadcastChannel(ALFA_ID_CHANNEL);

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state') || '';
  const error = urlParams.get('error');

  const isWebView = window.is_webview || false;

  const handleWebviewFlow = () => {
    const newUrl = new URL(`${window.location.origin}/main`);

    if (code) {
      newUrl.searchParams.set('code', code);
      newUrl.searchParams.set('state', state);
    }

    window.location.replace(newUrl.toString());
  };

  const handleBrowserFlow = () => {
    if (code) {
      const result: AlfaAuthResult = {
        success: true,
        payload: {
          code,
          state,
          redirect_url: `${window.location.origin}/login/alfabank`,
        },
      };
      channel.postMessage(result);
    } else {
      const result: AlfaAuthResult = {
        success: false,
        payload: {
          error: error || 'неизвестная ошибка',
          state,
        },
      };
      channel.postMessage(result);
    }

    channel.close();
    setTimeout(() => {
      window.close();
    }, 250);
  };

  if (isWebView) {
    handleWebviewFlow();
  } else {
    handleBrowserFlow();
  }
};
